import ScreenError from './ScreenError';

export type {IScreenErrorProps} from './ScreenError';
export default ScreenError;
